// extracted by mini-css-extract-plugin
module.exports = {"text-component__latex-wrapper":"style_text-component__latex-wrapper__2ZY1E"};